module.exports = __webpack_public_path__ + "static/78invgde-1d38d37207613448daa440973d9e01f4.gif";